import React, { PureComponent } from 'react';
import { Field } from 'redux-form';
import Button from 'components/Button/Button.component';
import * as Component from 'components/FormBuilder';
import { JsBridge } from 'utils';
import { isEmpty, get, has, memoize } from 'lodash';
// import { CACHE_FROM_PAYMENT } from 'constant/ConstVariable';

import {
  min10k,
  max10m,
  creditCard,
  len16,
} from 'components/FormBuilder/validation/validation';

import config from './FormBuilder.page.config';
import text from '../GeneralFormPage/GeneralFormPage.page.translation';

class FormPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      validationError: 'no',
    };
  }
  //  Be Careful add status cache please check all biller type shortly after
  // componentDidMount() {
  //   sessionStorage.setItem(CACHE_FROM_PAYMENT, true);
  // }

  _getShortestPrefix = memoize(prefixs => {
    const isPhoneInput =
      this.props.formObject[0].component === 'PhoneNumberInput';

    let shortest = get(prefixs[0], 'length') || 10;
    prefixs.forEach(prefix => {
      if (shortest > prefix.length) {
        shortest = prefix.length;
      }
    });

    return isPhoneInput ? shortest - 2 : shortest;
  });

  _getFieldName = component => {
    switch (component) {
      case 'AlphanumericCustomerNumber':
      case 'CreditCardInput':
      case 'NumericCustomerNumber':
      case 'NumericCustomerNumberNoPrefix':
      case 'PhoneNumberInput':
        return 'customer_number';
      case 'AmountInput':
      case 'AmountInputPredefined':
        return 'amount';
      default:
        return 'default';
    }
  };

  checkPhone = (value = '') => {
    const { vaPrefix: prefixs, formData, formObject } = this.props;
    const componentParse = JSON.parse(formData.components);
    const validationPrefix = has(componentParse, 'validationPrefix')
      ? get(componentParse, 'validationPrefix')
      : 'dynamic';
    const minLength = parseInt(
      get(formObject[0], `validation.minLength`, '10'),
      10,
    );
    const maxLength = parseInt(
      get(formObject[0], `validation.maxLength`, '13'),
      10,
    );

    let validationError = true;
    let stateValue = '';
    const shortestPrefixLength = this._getShortestPrefix(prefixs);

    const checkValue = value.split(' ').join('');

    if (checkValue) {
      if (checkValue.match(/^\(?(628|08)\)?\d/)) {
        validationError = validationPrefix === 'yes';
        stateValue = 'phone';
        this.setState({ validationError: 'no' });
      } else if (prefixs.length && validationPrefix !== 'no') {
        prefixs.forEach(prefix => {
          if (checkValue.substr(0, prefix.length).match(prefix)) {
            validationError = false;
            stateValue = 'prefix';
            this.setState({ validationError: 'dynamic' });
          }
        });
      }

      if (stateValue === 'phone' && checkValue.length < minLength) {
        return 'validation.custNumber';
      }

      if (
        stateValue === 'prefix' &&
        checkValue.length < shortestPrefixLength + minLength
      ) {
        return 'validation.custNumber';
      }

      if (checkValue.length > maxLength) {
        return 'validation.custNumberMax';
      }

      return validationError ? 'validation.incorrectPrefix' : undefined;
    }

    return 'validation.required';
  };

  checkPrefix = (value = '') => {
    const { vaPrefix: prefixs, formData, formObject } = this.props;
    const componentParse = JSON.parse(formData.components);
    const validationPrefix = has(componentParse, 'validationPrefix')
      ? get(componentParse, 'validationPrefix')
      : 'dynamic';

    const minLength = parseInt(
      get(formObject[0], `validation.minLength`, '5'),
      10,
    );
    const maxLength = parseInt(
      get(formObject[0], `validation.maxLength`, '18'),
      10,
    );

    let validationError = true;
    let prefixSelected = false;
    const checkValue = value.split(' ').join('');

    const shortestPrefixLength = this._getShortestPrefix(prefixs);

    if (validationPrefix === 'no') {
      if (checkValue.length < minLength) {
        this.setState({ validationError: 'no' });
        return 'validation.custNumber';
      }

      return undefined;
    }

    if (validationPrefix === 'dynamic') {
      validationError = false;
    }
    if (checkValue) {
      prefixs.forEach(prefix => {
        if (checkValue.substr(0, prefix.length).match(prefix)) {
          validationError = false;
          prefixSelected = true;
        }
      });

      if (validationPrefix === 'dynamic' && !prefixSelected) {
        if (checkValue.length < minLength) {
          this.setState({ validationError: 'no' });

          return 'validation.custNumber';
        }
        return validationError && checkValue.length > 4
          ? 'validation.incorrectPrefix'
          : undefined;
      }

      if (checkValue.length < minLength + shortestPrefixLength) {
        this.setState({ validationError: 'dynamic' });
        return 'validation.custNumber';
      }
      if (checkValue.length > maxLength) {
        return 'validation.custNumberMax';
      }

      return validationError && checkValue.length > 4
        ? 'validation.incorrectPrefix'
        : undefined;
    }

    return 'validation.required';
  };

  _getValidation = component => {
    switch (component) {
      case 'CreditCardInput':
        return [creditCard, len16];
      case 'AlphanumericCustomerNumber':
      case 'NumericCustomerNumber':
        return [this.checkPrefix];
      case 'AmountInput':
      case 'AmountInputPredefined':
        return [min10k, max10m];
      case 'PhoneNumberInput':
        return [this.checkPhone];
      default:
        return [];
    }
  };

  _onSubmit = value => {
    this.props.onSubmit(value);
  };

  _renderBtnText = (formData, lang) => {
    const {
      intl: { formatMessage },
      isGenesis,
    } = this.props;

    const defaultText = formatMessage(text.buttonNext);

    if (isEmpty(formData) || formData.components === '') {
      return defaultText.toUpperCase();
    }
    const componentParse = JSON.parse(formData.components);
    const buttonText = isGenesis
      ? get(componentParse, `${lang}.paymentBtnText`, defaultText)
      : get(componentParse, `${lang}.btnText`, defaultText);
    return buttonText.toUpperCase();
  };

  render() {
    const {
      formData,
      formObject,
      intl,
      handleSubmit,
      lang,
      valueChanged,
    } = this.props;

    const componentParse = JSON.parse(formData.components);

    const validationPrefix = get(componentParse, 'validationPrefix');

    let limitDefault;
    switch (formObject[0].component) {
      case 'PhoneNumberInput':
        limitDefault = {
          min: '10',
          max: '13',
        };
        break;
      case 'CreditCardInput':
        limitDefault = {
          min: '16',
          max: '16',
        };
        break;
      default:
        limitDefault = {
          min: '5',
          max: '18',
        };
        break;
    }

    const limitMin = parseInt(
      get(formObject[0], `validation.minLength`, limitDefault.min),
      10,
    );
    const limitMax = parseInt(
      get(formObject[0], `validation.maxLength`, limitDefault.max),
      10,
    );
    const shortestPrefixLength = this._getShortestPrefix(this.props.vaPrefix);
    const limitInputMin =
      this.state.validationError !== 'no' &&
      formObject[0].component !== 'CreditCardInput'
        ? limitMin + shortestPrefixLength
        : limitMin;

    return (
      <form
        onSubmit={e => {
          e.preventDefault();
        }}
      >
        <div className="form-area">
          {formObject.map(field => {
            const otherProps = {
              intl,
              helper: get(field, `config.${lang}.helper`, null),
              ...get(field, `config.${lang}.general`, null),
              target: validationPrefix,
              limit: {
                min: limitInputMin,
                max: limitMax,
              },
              withSeparator: formObject.length > 1,
            };
            return (
              <Field
                key={field.name}
                name={this._getFieldName(field.component)}
                component={Component[field.component]}
                onChange={valueChanged(this._getFieldName(field.component))}
                validate={this._getValidation(field.component)}
                JsBridge={JsBridge}
                {...otherProps}
              />
            );
          })}
        </div>
        <div className="button-submit">
          <Button
            id="btn_change"
            addClass="primary full no-margin"
            action={handleSubmit(this._onSubmit)}
          >
            <span>{this._renderBtnText(formData, lang)}</span>
          </Button>
        </div>
      </form>
    );
  }
}

FormPage.propTypes = config.propTypes;
FormPage.displayName = config.displayName;
FormPage.defaultProps = config.defaultProps;

export default FormPage;
